import React from "react";
import {
  ActionList,
  ActionGroup,
  Action,
} from "./../../mood-ui/DataTable";

const QuestionListActions = ({ onClearSelection, onPublish }) => (
  <ActionList onClearSelection={onClearSelection}>
    <ActionGroup>
      <Action label="Publish" onClick={onPublish} />
    </ActionGroup>
  </ActionList>
);

export default QuestionListActions;
